import { NavigationMenuView } from '@msdyn365-commerce-modules/navigation-menu';

export default NavigationMenuView;
